import moment from 'moment-timezone';

import { DATE_RANGE_CUSTOM, decodeCustomRange, encodeFilterValue } from '../registry/filters';
import { ISO_DATE_FORMAT } from './useInsightFilters';

/** `08.07.2026 – 08.08.2026`: how the filter bar's Date Range chip prints a custom window. */
export const CHIP_DATE_FORMAT = 'DD.MM.YYYY';

/**
 * Formats the sub-value of a `custom:<start>..<end>` date-range selection. Shared by the Customer
 * Insights filter bar and the Orbit context chips so both print one window the same way; an
 * unparseable sub-value is returned as it was stored rather than replaced with a placeholder.
 */
export const formatCustomRangeDetail = (subValue: string): string => {
  const range = decodeCustomRange(encodeFilterValue(DATE_RANGE_CUSTOM, subValue));

  if (!range) {
    return subValue;
  }

  return range
    .map(date => moment(date, ISO_DATE_FORMAT, true).format(CHIP_DATE_FORMAT))
    .join(' – ');
};

export default formatCustomRangeDetail;
